export const stripHtml = (str) => {
  if (typeof str === 'string') {
    return str.replace(/<[^>]*(>|$)|&nbsp;|&emsp;|&raquo;|&laquo;|&gt;/g, ' ');
  } else {
    return str;
  }
};
